<template>
  <div class="bg-white rounded-2xl shadow-lg p-6">
    <div class="mb-6">
      <h2 class="text-2xl font-bold text-gray-900 flex items-center gap-3 mb-2">
        <span class="text-3xl">📖</span>
        <span>学习与发展路径</span>
      </h2>
      <p class="text-gray-600 text-lg">根据您的职业类型提供的发展建议</p>
    </div>

    <div class="grid md:grid-cols-2 gap-6">
      <!-- 推荐学习方向 -->
      <div class="p-6 bg-blue-50 rounded-xl border border-blue-200">
        <h4 class="text-lg font-semibold text-blue-900 mb-4 flex items-center gap-2">
          <span>📚</span>
          <span>推荐学习方向</span>
        </h4>
        <ul class="space-y-3">
          <li 
            v-for="(item, index) in majors"
            :key="index"
            class="flex items-start gap-2 text-gray-700"
          >
            <span class="text-blue-500 mt-0.5">•</span>
            <span class="text-sm leading-relaxed">{{ item }}</span>
          </li>
        </ul>
      </div>

      <!-- 能力提升建议 -->
      <div class="p-6 bg-orange-50 rounded-xl border border-orange-200">
        <h4 class="text-lg font-semibold text-orange-900 mb-4 flex items-center gap-2">
          <span>🎯</span>
          <span>能力提升建议</span>
        </h4>
        <ul class="space-y-3">
          <li 
            v-for="(item, index) in developmentSuggestions"
            :key="index"
            class="flex items-start gap-2 text-gray-700"
          >
            <span class="text-orange-500 mt-0.5">•</span>
            <span class="text-sm leading-relaxed">{{ item }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 学习与发展路径组件
 * 展示推荐的学习方向和能力提升建议
 */
export default {
  name: 'LearningPath',
  props: {
    majors: {
      type: Array,
      required: true
    },
    developmentSuggestions: {
      type: Array,
      required: true
    }
  }
}
</script>

